import { component } from "picoapp";

export const gridVideo = component((node: HTMLElement) => {
  const video = node.querySelector("video");
  const pauseButton = node.querySelector("[data-pause]");
  const playButton = node.querySelector("[data-play]");

  const pauseVideo = () => {
    video.pause();
    (pauseButton as HTMLElement).style.display = "none";
    (playButton as HTMLElement).style.display = "block";
  };

  const playVideo = () => {
    video.play();
    (playButton as HTMLElement).style.display = "none";
    (pauseButton as HTMLElement).style.display = "block";
  };

  pauseButton?.addEventListener("click", pauseVideo);

  playButton?.addEventListener("click", playVideo);

  return () => {
    pauseButton.removeEventListener("click", pauseVideo);
    playButton.removeEventListener("click", playVideo);
  };
});
